import { ENTITIES } from "@/lib/metadataConstants";

export default function EntitySidebar({ active, counts, onSelect }) {
  return (
    <aside className="col-span-12 md:col-span-3" data-testid="metadata-sidebar">
      <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] mb-2">
        Entities
      </div>
      <nav className="ml-card overflow-hidden" data-testid="entity-nav">
        {ENTITIES.map((ent) => (
          <EntityRow
            key={ent.slug}
            entity={ent}
            isActive={ent.slug === active}
            count={counts[ent.slug] ?? 0}
            onSelect={onSelect}
          />
        ))}
      </nav>
    </aside>
  );
}

function EntityRow({ entity, isActive, count, onSelect }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(entity.slug)}
      data-testid={`entity-${entity.slug}`}
      data-active={isActive}
      className={`w-full px-4 py-3 text-left border-b last:border-b-0 border-[var(--ml-border)] transition-colors flex items-center justify-between gap-3 ${
        isActive
          ? "bg-[var(--ml-primary)]/8 border-l-2 border-l-[var(--ml-primary)]"
          : "hover:bg-[var(--ml-surface)] border-l-2 border-l-transparent"
      }`}
    >
      <div className="min-w-0">
        <div
          className={`text-sm ${
            isActive
              ? "font-semibold text-[var(--ml-primary)]"
              : "font-medium"
          }`}
        >
          {entity.label}
        </div>
        <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">
          {entity.source}
        </div>
      </div>
      <span
        className="ml-mono text-[11px] uppercase tracking-widest text-[var(--ml-text-secondary)] tabular-nums"
        data-testid={`entity-${entity.slug}-count`}
      >
        {count}
      </span>
    </button>
  );
}
